// Reusable project color palette (pastel/soft, professional).
// Used by ProjectIcon and any other component showing project avatars.

export const PROJECT_COLORS = [
  { id: 'slate',   bg: '#E2E8F0', text: '#334155', ring: '#94A3B8' },
  { id: 'red',     bg: '#FEE2E2', text: '#991B1B', ring: '#F87171' },
  { id: 'orange',  bg: '#FFEDD5', text: '#9A3412', ring: '#FB923C' },
  { id: 'amber',   bg: '#FEF3C7', text: '#92400E', ring: '#FBBF24' },
  { id: 'lime',    bg: '#ECFCCB', text: '#3F6212', ring: '#A3E635' },
  { id: 'emerald', bg: '#D1FAE5', text: '#065F46', ring: '#34D399' },
  { id: 'teal',    bg: '#CCFBF1', text: '#115E59', ring: '#2DD4BF' },
  { id: 'cyan',    bg: '#CFFAFE', text: '#155E75', ring: '#22D3EE' },
  { id: 'sky',     bg: '#E0F2FE', text: '#075985', ring: '#38BDF8' },
  { id: 'indigo',  bg: '#E0E7FF', text: '#3730A3', ring: '#818CF8' },
  { id: 'violet',  bg: '#EDE9FE', text: '#5B21B6', ring: '#A78BFA' },
  { id: 'fuchsia', bg: '#FAE8FF', text: '#86198F', ring: '#E879F9' },
  { id: 'pink',    bg: '#FCE7F3', text: '#9D174D', ring: '#F472B6' },
  { id: 'rose',    bg: '#FFE4E6', text: '#9F1239', ring: '#FB7185' },
];

const PROJECT_COLOR_BY_ID = Object.fromEntries(PROJECT_COLORS.map(c => [c.id, c]));

// Stable string hash → unsigned int
function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

/**
 * Resolve color for a project.
 * 1. Use backend-assigned `project.color` (preferred, persistent)
 * 2. Fallback: deterministic from project.id / name (for legacy projects without a color)
 */
export function getProjectColor(project) {
  if (!project) return PROJECT_COLORS[0];
  if (project.color && PROJECT_COLOR_BY_ID[project.color]) {
    return PROJECT_COLOR_BY_ID[project.color];
  }
  const seed = project.id || project.name || 'project';
  return PROJECT_COLORS[hashString(seed) % PROJECT_COLORS.length];
}

/**
 * Initials of a project name (max 2 characters).
 * - "Geliştirme Projesi"  → "GP"
 * - "Web"                 → "W"
 * - "Yapay Zeka Asistanı" → "YZ"
 */
export function getProjectInitials(name) {
  if (!name || typeof name !== 'string') return '?';
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}
